import moment from 'moment';

// Parse a service-provided date and return a moment instance in local mode.
function parseDate(dateValue) {
    return moment.utc(dateValue.replace(" +0000", "")).local();
};

export default parseDate;